<template>
  <div class="modal-goodsClass">
    <div class="modal">
      <div class="modal-header">
        <div style="padding: 6px;">图片列表</div>
        <button type="button" class="btn-close" @click="closeSelf">关闭</button>
      </div>
      <div class="modal-body" style="height: 300px;">
        <el-image v-for="(item,i) in pictureList" :key="i"  style="width: 200px; height: 200px;margin-left:40px" :src="item" :preview-src-list="pictureList"></el-image>
      </div>
      <div class="modal-footer"></div>
    </div>
  </div>
</template>

<script>
import { timeStr } from "@/common/times";
import { hex_md5 } from "@/common/Base64MD5";
import { getStaffCode } from "@/utils/auth";

export default {
  name: "Add",
  data() {
    return {
      loading: false,
      iconDialog: false,
      pictureList: [],
      imgurl:this.$imgUrl
    };
  },

  methods: {
    init(row) {
      this.pictureList = [];
      this.$axios({
        method: "post",
        url: this.$shopUrl + "Report/GetPictureList",
        data: {
          timeStr: timeStr,
          sign: hex_md5("timeStr=" + timeStr + "&key=" + this.$signKey),
          staffCode: getStaffCode(),
          reportCode: row.reportCode,
        },
      })
        .then((response) => {
          console.log(response);
          if (response.data.error == 0) {
             response.data.data.forEach((element) => {
              this.pictureList.push(this.$imgUrl + element.url);
            });
          } else if (response.data.error == 1) {
            this.$message.error(response.data.message);
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    closeSelf() {
      this.$emit("closeAdd");
    },
    confirm(addForm) {
      this.$refs[addForm].validate((valid) => {
        if (valid) {
          this.addSubmit();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>




<style lang="scss" scoped>
.modal-goodsClass {
  position: fixed;
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.3);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 99;

  .modal {
    background-color: #fff;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);
    overflow-x: auto;
    display: flex;
    flex-direction: column;
    border-radius: 10px;
    width: 700px;

    .modal-header {
      border-bottom: 1px solid #eee;
      color: #313131;
      justify-content: space-between;
      padding: 10px;
      display: flex;
    }
    .modal-body .avatar-uploader .el-upload {
      border: 1px dashed #d9d9d9;
      border-radius: 6px;
      cursor: pointer;
      position: relative;
      overflow: hidden;
      width: 100px;
      height: 100px;
    }
    .modal-body .avatar-uploader .el-upload:hover {
      border-color: #409eff;
    }

    /deep/ .modal-body .el-icon-circle-close{
        color: white;
    }

    .modal-body .avatar-uploader-icon {
      font-size: 28px;
      color: #8c939d;
      width: 100px;
      height: 100px;
      line-height: 100px;
      text-align: center;
    }
    .modal-body .avatar {
      width: 100%;
      height: 100%;
      border-radius: 6px;
      display: block;
    }
    .modal-body /deep/ .el-upload--picture-card {
      width: 100px;
      height: 100px;
      line-height: 100px;
    }
    .modal-body {
      position: relative;
      padding: 20px 0px;
      z-index: 99;
      height: 100%;
    }
    .modal-footer {
      border-top: 1px solid #eee;
      justify-content: flex-end;
      padding: 15px;
      display: flex;
    }
    .uploadButton {
      border-top: 1px solid #eee;
      padding: 10px 0 0;
      display: flex;
      .el-button {
        width: 100px;
      }
    }
  }
}

.btn-close,
.btn-confirm {
  border-radius: 8px;
  margin-left: 16px;
  width: 56px;
  height: 36px;
  border: none;
  cursor: pointer;
}
.btn-close {
  color: #313131;
  background-color: transparent;
}

.row {
  padding: 10px 0px;
}
.item {
  padding: 0px 20px;
}
.label {
  padding: 5px 0px;
}
</style>
